import { http } from '../core/services/http'
import { IAuthorProfile, IUserSearchResult } from '../core/interfaces'
import { SimpleSearchPaginationParams, Pagination } from '../core/services/utils'
import { UUID } from 'node:crypto'

export const getAllAuthorProfiles = (params?: SimpleSearchPaginationParams) => {
    return http.get<Pagination<IAuthorProfile>>('/api/dashboard/blog-author-profiles', { params })
}

export const createAuthorProfile = (data: IAuthorProfile) => {
    return http.post<IAuthorProfile>('/api/dashboard/blog-author-profiles', data)
}

export const updateAuthorProfile = (id: UUID, data: IAuthorProfile) => {
    return http.put<IAuthorProfile>(`/api/dashboard/blog-author-profiles/${id}`, data)
}

export const deleteAuthorProfile = (id: UUID) => {
    return http.delete(`/api/dashboard/blog-author-profiles/${id}`)
}

export const searchUsers = (q: string) => {
    return http.get<IUserSearchResult[]>('/api/dashboard/blog-author-profiles/users/search', { params: { q } })
}
